import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-body p-0 d-flex justify-content-between flex-column overflow-hidden" }
const _hoisted_2 = { class: "d-flex flex-stack flex-grow-1 px-9 pt-9 pb-3" }
const _hoisted_3 = { class: "d-flex flex-column" }
const _hoisted_4 = { class: "text-dark fw-bolder fs-3" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "spinner-border spinner-border-sm align-middle ms-2 text-primary"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-sync-alt" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 0,
  class: "text-muted fw-bold fs-7"
}
const _hoisted_10 = {
  key: 1,
  class: "text-muted fw-bold fs-7"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.I18nUtils.translate("sea.widgets.monthlyOrdersCount.title")) + " ", 1),
            (_ctx.countData && _ctx.countData.branch)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, " [" + _toDisplayString(_ctx.countData.branch.name.replace("Sushi Eden - ", "")) + "] ", 1))
              : _createCommentVNode("", true),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6))
              : (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args))),
                  type: "button",
                  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
                }, _hoisted_8))
          ]),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Date Period "))
            : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.getDateRange), 1))
        ])
      ]),
      _createVNode(_component_apexchart, {
        class: "mixed-widget-10-chart",
        options: _ctx.chartOptions,
        series: _ctx.series,
        type: "bar",
        height: _ctx.chartHeight
      }, null, 8, ["options", "series", "height"])
    ])
  ], 2))
}